export function TargetArrowIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9_48)">
        <path
          d="M18.4481 0.982422L19.1337 4.86621L23.0175 5.55176L23.2069 5.58496L19.0331 9.75879L19.0038 9.78711H15.5692L12.8905 12.4639C13.0395 12.7969 13.1239 13.1651 13.1239 13.5527C13.1238 15.0286 11.923 16.2295 10.4471 16.2295C8.97146 16.2293 7.7715 15.0284 7.77136 13.5527C7.77136 12.0769 8.97137 10.8762 10.4471 10.876C10.8342 10.876 11.2024 10.9598 11.535 11.1084L14.2128 8.43164V4.99609L18.4149 0.793945L18.4481 0.982422ZM10.4471 12.7939C10.029 12.7942 9.68835 13.1345 9.68835 13.5527C9.68849 13.9708 10.0291 14.3113 10.4471 14.3115C10.8654 14.3115 11.2068 13.971 11.2069 13.5527C11.2069 13.1344 10.8655 12.7939 10.4471 12.7939ZM16.1298 5.79004V7.87012H18.2098L19.245 6.83301L17.5477 6.5332L17.4784 6.52148L17.4667 6.45215L17.1669 4.75293L16.1298 5.79004Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M12.6943 6.2583L12.5674 6.22119C11.8876 6.02509 11.1748 5.92236 10.4473 5.92236C6.24049 5.9225 2.81752 9.34547 2.81738 13.5522C2.81738 17.7615 6.238 21.182 10.4473 21.1821C14.6542 21.1821 18.0771 17.7592 18.0771 13.5522C18.0771 12.8237 17.9765 12.1131 17.7803 11.4331L17.7432 11.3052H19.7246L19.7432 11.3823C19.9094 12.0907 19.9951 12.8192 19.9951 13.5522C19.9951 18.8168 15.7119 23.1001 10.4473 23.1001C5.17811 23.1 0.900391 18.8214 0.900391 13.5522C0.900526 8.28786 5.18283 4.00551 10.4473 4.00537C11.1869 4.00537 11.9142 4.08925 12.6172 4.25244L12.6943 4.271V6.2583Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_48">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
